















































































import { useVModel } from '@vueuse/core';
import { PropType, defineComponent } from '@vue/composition-api';

import { requiredValidator } from '@/utils/validators';

import { ISystemError, IWorkflowStateReminderConfigData } from '@/models';

export default defineComponent({
  name: 'WorkflowStateReminderConfigFormFields',
  props: {
    value: {
      type: Object as PropType<IWorkflowStateReminderConfigData>,
      required: true
    },
    error: {
      type: Object as PropType<ISystemError | null>,
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const reminderConfigData = useVModel(props, 'value', emit, {
      passive: true
    });

    return {
      reminderConfigData,
      requiredValidator
    };
  }
});
